import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { DriverSettingsService } from '@app/features/dashboard/settings/driver-settings.service';

// Sole owner of navigation items and routing.
@Injectable({ providedIn: 'root' })
export class NavigationHandler {
  private readonly router = inject(Router);
  private readonly driverSettingsService = inject(DriverSettingsService);

  public readonly currentNavigationItem = signal<string>('driver');
  public readonly previousNavigationItem = signal<string>('driver');

  // Non router navigation for dialogs
  public readonly openSettings = signal<boolean>(false);
  public readonly switchingOrganisation = signal<boolean>(false);

  public readonly isInitialized = signal<boolean>(false);

  // This could be helpful for future use cases (dynamic navigation)
  /*  addItem(item: NavigationItemModel): void {
    this._items.update((list) => [...list, item]);
  }*/

  public navigate(id: string) {
    // use this flag only for links where you stay. not for popups
    switch (id) {
      case 'driver':
        void this.goToDashboard();
        break;
      case 'settings':
        void this.goToSettings();
        break;
      case 'charges':
        void this.goToCharges();
        break;
      case 'export':
        this.goToStatements();
        break;
    }

    // This needs to stay at the bottom, because the above methods might trigger a navigation which would override the current item
    this.currentNavigationItem.set(id);
  }

  public restorePreviousItem() {
    this.currentNavigationItem.set(this.previousNavigationItem());
  }

  public goToDashboard(replaceUrl = false, driverId: string | null = null) {
    this.currentNavigationItem.set('driver');

    if (driverId) {
      return this.router.navigate(['/admin'], {
        queryParams: { driver: driverId },
        replaceUrl: replaceUrl,
      });
    }

    return this.router.navigate(['/admin'], { replaceUrl: replaceUrl });
  }

  public goToSettings(settingsItem?: string) {
    // Store the previous item to navigate back to it after closing the settings
    this.previousNavigationItem.set(this.currentNavigationItem());
    if (settingsItem) {
      this.driverSettingsService.selectedSettingsItem.set(settingsItem);
    }
    this.openSettings.set(true);
  }

  public goToCharges(replaceUrl = false) {
    this.currentNavigationItem.set('charges');
    return this.router.navigate(['/admin/charges'], { replaceUrl: replaceUrl });
  }

  public goToStatements(replaceUrl = false) {
    this.currentNavigationItem.set('export');
    return this.router.navigate(['/admin/statements'], { replaceUrl: replaceUrl });
  }
}
